import {
    ChangeDetectorRef,
    Component,
    Input,
    forwardRef,
    ChangeDetectionStrategy,
    inject,
    output,
} from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

let nextUniqueId = 0;

@Component({
    selector: 'app-single-select-menu',
    templateUrl: './single-select-menu.component.html',
    styleUrl: './single-select-menu.component.scss',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SingleSelectMenuComponent),
            multi: true,
        },
    ],
})
export class SingleSelectMenuComponent implements ControlValueAccessor {
    private cdr = inject(ChangeDetectorRef);

    private readonly instanceId = nextUniqueId++;

    @Input()
    set options(value: { [key: string]: any }) {
        if (!value) {
            this.optionEntries = [];
            return;
        }

        this.optionEntries = Object.entries(value).map(
            ([label, optionValue], index) => ({
                label,
                value: optionValue,
                id: `singleSelect_${this.instanceId}_${index}`,
            }),
        );
    }

    @Input() groupName: string = `singleSelectGroup_${this.instanceId}`;
    @Input() selectedValue: any;
    readonly selectedValueChange = output<any>();

    protected optionEntries: Array<{ label: string; value: any; id: string }> =
        [];
    protected isDisabled: boolean = false;

    private onChange: (value: any) => void = () => {};
    private onTouched: () => void = () => {};

    writeValue(value: any): void {
        this.selectedValue = value;
        this.cdr.markForCheck();
    }

    registerOnChange(fn: (value: any) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
        this.cdr.markForCheck();
    }

    onValueChange(value: any): void {
        this.selectedValue = value;
        this.onChange(value);
        this.onTouched();
        this.selectedValueChange.emit(value);
    }
}
